import React, { useContext, useState } from "react";

import ArticleFilterBar from "../../src/components/Content/Article/ArticleFilterBar";
import Articles from "../../src/components/Content/Article/Articles";
import MainLayout from "../../src/components/Layout/MainLayout";
import SeoHead from "../../src/components/Seo/SeoHead";
import { default as categoriesConfig } from "../../src/categoriesArticles.json";
import { createFetcher } from "src/lib/fetcher";
import { makeStyles } from "@material-ui/core";
import { queryArticles } from "../../src/graphql/queries";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme) => ({}));

const Page = (props) => {
  const { prefetchedArticleList } = props;
  const classes = useStyles();
  const { t } = useTranslation("common");

  const category = "all";
  const categoryKey = category.replace("-", "_");

  return (
    <MainLayout
      searchBar="blogSticky"
      contentClassName={classes.blogContent}
      menuComponent={
        <ArticleFilterBar
          activeCategory={category}
          categories={categoriesConfig.categoriesInBlog}
          articleGroup="blog"
        />
      }
    >
      <SeoHead
        title={t(`articleCategory_${categoryKey}_title`)}
        description={t(`articleCategory_${categoryKey}_short`)}
        ogDescription={t(`articleCategory_${categoryKey}_short`)}
      />
      <Articles prefetchedData={prefetchedArticleList} defaultCategory={category} articleGroup="blog" />
    </MainLayout>
  );
};

export async function getStaticProps({ locale }) {
  const fetcher = createFetcher();
  const data = await fetcher([
    queryArticles,
    JSON.stringify({
      action: "search",
      categories: categoriesConfig.categoriesInBlog,
      visibility: "public",
      size: 100,
      locale,
    }),
  ]);

  const allArticles = data?.queryArticles?.items || [];
  const articles = allArticles.filter((article) => article.locale == "de");

  return {
    props: {
      prefetchedArticleList: articles,
      key: "all", // force state reset for dynamic route
    },
    revalidate: 60 * 2,
  };
}

export default Page;
